import { AmountInterface } from '../../../../layout/interfaces/amount-interface';
import { RateInterface } from '../../../../layout/interfaces/rate-interface';
import { AgeIntervalInterface } from '../../../../shared/interfaces/age-interval-interface';
import { LegacyPriceInfoDto } from '../../generated';
import { CartPersonInterface } from '../cart';
import { Product } from './product';

export class Person implements CartPersonInterface {
  age: number;
  name?: string;
  get products() {
    return this.productEntities.map(p => ({
      definitionId: p.definitionId,
      addons: p.addons.map(a => a.definitionId)
    }));
  }

  set products(prods) {}

  productEntities: Product[] = [];

  weight?: string;
  height?: string;
  shoe_size?: string;
  skill?: string;
  ageInterval?: AgeIntervalInterface;
  isAdult = true;
  discounts?: LegacyPriceInfoDto;
  birthday?: string;

  get ageCategoryType() {
    if (this.ageInterval?.age_category.image_male.startsWith('child')) {
      return 'child';
    } else if (this.ageInterval?.age_category.image_male.startsWith('youth')) {
      return 'teen';
    } else {
      return 'adult';
    }
  }

  get totalOfItemsAndAddons() {
    return this.productEntities.reduce((count, product) => count + 1 + product.addons.length, 0);
  }

  /**
   * returns the sub-total for all of this persons products including addons
   * @param days the number of days you want to rent items for
   * @param rates the euro based exchange rates
   * @param forCurrency the target currency you want to display
   * @returns an AmountInterface containing the total in given currency (without rates)
   */
  getTotalOnlinePrice(days: number, rates: RateInterface, forCurrency: string): AmountInterface {
    let total = 0;
    this.productEntities.forEach(product => {
      total += product.getTotalOnlinePrice(days, this, rates, forCurrency).amount;
    });

    return { amount: total, currency: { code: forCurrency, rates: {} } };
  }

  getTotalShopPrice(days: number, rates: RateInterface, forCurrency: string): AmountInterface {
    let total = 0;
    this.productEntities.forEach(product => {
      total += product.getTotalShopPrice(days, rates, forCurrency).amount;
    });

    return { amount: total, currency: { code: forCurrency, rates: {} } };
  }
}
